import React from "react";
import {
  Navbar,
  MobileNav,
  Typography,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
  IconButton,
} from "@material-tailwind/react";
import {
  UserCircleIcon,
  ChevronDownIcon,
  PowerIcon,
  Bars2Icon,
} from "@heroicons/react/24/solid";
import { logo } from "../../assets/Images";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useReduxStore } from "../../hooks/useReduxStore.js";
import { LogoutAction } from "../../store/Actions/action.js";
import { getFirstName, scrollToTop } from "../../helper/helper.js";
import { ImageUrl } from "../../services/API.js";
// profile menu component
const profileMenuItems = [
  {
    label: "My Account",
    icon: UserCircleIcon,
    route: "/Dashboard/Profile",
  },
  // {
  //   label: "My Cart",
  //   icon: ShoppingCartIcon,
  //   route: "/AddToCart",
  // },
  {
    label: "Sign Out",
    icon: PowerIcon,
    route: "/",
  },
];

function ProfileMenu({}) {
  const { dispatch, getState } = useReduxStore();
  const { userData,token } = getState("AUTH");
 
  const { name, email, avatar } = userData || {};
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const closeMenu = () => setIsMenuOpen(false);
  const handleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const onProfileMenuClick = (route, isLastItem) => {
    isLastItem && dispatch(LogoutAction());
    navigate(route);
    isLastItem && scrollToTop();
    closeMenu();
  };

  return (
    <Menu
      open={isMenuOpen}
      className="w-fit bg-white "
      handler={handleMenu}
      placement="bottom-end"
    >
      <MenuHandler>
        <Button
          variant="text"
          color="blue-gray"
          className="flex items-center gap-1 rounded-full py-0.5 pr-2 pl-0.5 "
        >
          <Avatar
            variant="circular"
            size="sm"
            alt="tania andrew"
            className="border border-white p-0.5"
            src={
              avatar ||
              "https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
            }
          />
          <small className="px-1 text-white">
            {getFirstName(userData?.name)}
          </small>
          <ChevronDownIcon
            strokeWidth={2.5}
            className={`h-3 w-3 transition-transform ${
              isMenuOpen ? "rotate-180" : ""
            }`}
          />
        </Button>
      </MenuHandler>
      <MenuList className="p-1 z-[9999999]">
        {profileMenuItems.map(({ label, icon, route }, key) => {
          const isLastItem = key === profileMenuItems.length - 1;
          return (
            <MenuItem
              key={label}
              onClick={() => onProfileMenuClick(route, isLastItem)}
              className={`flex items-center gap-2 rounded ${
                isLastItem
                  ? "hover:bg-white/50 focus:bg-white/50 active:bg-white/50"
                  : ""
              }`}
            >
              {React.createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-white" : ""}`,
                strokeWidth: 2,
              })}
              <Typography
                as="span"
                variant="small"
                className="font-normal"
                color={isLastItem ? "red" : "inherit"}
              >
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}

function NavList({
  category,
  data = [],
  selectedCategory,
  toggleIsNavOpen,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const onNavBarItemPress = (selectedCategory) => {
    toggleIsNavOpen && toggleIsNavOpen();
    // navigate("/ProductCollection", { state: {} });
    // onCategoryPress && onCategoryPress(selectedCategory);
    navigate(selectedCategory?.route, { state: {} });

  };

  return (
    <ul className="mt-6 mb-4 flex flex-col gap-6 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center  ">
      {data.map((item, key) => {
        let { icon, type, id, label, route } = item;
        // Check if current route matches the item route
        const isActive = location.pathname === route;

        return (
          <Typography
            key={label}
            variant="small"
            color="black"
            className="font-medium text-secondary "
          >
            <MenuItem
              onClick={() => onNavBarItemPress(item)}
              className={
                isActive
                  ? "flex items-center bg-[#3662E3] focus:bg-[#3662E3] active:bg-[#3662E3] lg:rounded-full hover:bg-blue-700 lg:px-4 transition-colors duration-200"
                  : "flex items-center focus:bg-[#3662E3] active:bg-[#3662E3] lg:rounded-full hover:bg-[#3662E3] lg:px-4 transition-colors duration-200"
              }
            >
              {/* {React.createElement(icon, { className: "h-[25px] w-[25px]" })}{" "} */}
              <span className={`text-base md:text-xl transition-colors duration-200 ${
                isActive ? "text-white font-semibold" : "text-white"
              }`}>
                {" "}
                {label}
              </span>
            </MenuItem>
          </Typography>
        );
      })}
    </ul>
    // <SelectBoxSimple
    //   onItemClick={onNavBarItemPress}
    //   data={data}
    //   labelColor={"text-white"}
    //   label={"Browse Category"}
    //   selected={selectedCategory}
    //   labelClassName="text-sm"
    // />
  );
}

export function Navbar2({ category }) {
  const { getState } = useReduxStore();
  const { categories, selectedCategory } = getState("Home");
  const { token,settings, subscription: authSubscriptions } = getState("AUTH") || {};
  const { dashBoardData } = getState("Home") || {};
  const currentSubscription = dashBoardData?.subscription || (Array.isArray(authSubscriptions) ? authSubscriptions[0] : null);
  const planName = (currentSubscription?.planId?.name || 'Free').toLowerCase();
  const isFreePlan = planName === 'free';
   let menuData=[
  //   {
  //   label: "Home",
  //   icon: UserCircleIcon,
  //   route: "/",
  // },
  //   {
  //   label: "Forecast",
  //   icon: UserCircleIcon,
  //   route: "/Forecast",
  // },
    {
    label: "Pricing",
    icon: UserCircleIcon,
    route: "/Pricing",
  },

    {
    label:token?"Dashboard": "Login/Signup",
    icon: UserCircleIcon,
    route: token?"/Dashboard":"/",
  },
]
  if (token && isFreePlan) {
    menuData = menuData.filter(item => item.route !== "/Forecast");
  }
  const [isNavOpen, setIsNavOpen] = React.useState(false);
  const toggleIsNavOpen = () => setIsNavOpen((cur) => !cur);
  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setIsNavOpen(false)
    );
  }, []);
  return (
    <Navbar
      color="black"
      fullWidth
      className="mx-auto max-w-screen px-2 py-1 bg-[#20293F] lg:px-10 md:py-4 md:pt-8 top-0 z-[9999] shadow-sm border-none rounded-none"
    >
      <div className="relative px-2 lg:px-12 mx-auto flex items-center justify-between text-white container">
        <Link to={"/"}>
          <img
            className="object-contain object-center mt-2 md:mt-0 h-16 w-24 md:h-24 md:w-36"
            src={settings?.brandLogo?`${ImageUrl}${settings?.brandLogo}`:logo}
          />
        </Link>
        <div className="hidden lg:gap-6 lg:flex lg:flex-row items-center justify-center">
          <NavList
            selectedCategory={selectedCategory}
            category={category}
            data={menuData}
          />
        </div>

        <IconButton
          size="sm"
          color="white"
          variant="text"
          onClick={toggleIsNavOpen}
          className="ml-auto mr-2 lg:hidden hover:bg-transparent focus:bg-transparent active:bg-transparent"
        >
          <Bars2Icon className="h-8 w-8 text-white" />
        </IconButton>
      </div>
      <MobileNav
        open={isNavOpen}
        className="bg-[#20293F] w-full px-3 pt-2 "
      >
        <NavList
          toggleIsNavOpen={toggleIsNavOpen}
          selectedCategory={selectedCategory}
          data={menuData}
          category={category}
        />
      </MobileNav>
    </Navbar>
  );
}

